import type { ReactNode } from 'react'
import { Download } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { FilterDropdown } from '@/components/ui/filter-dropdown'
import type { EngagementEventRegistrations } from '@/lib/engagement-event-registrations'

export function EventListHeader({
  data,
  params,
  update,
  csvHref,
  csvAction,
}: {
  data?: EngagementEventRegistrations
  params: URLSearchParams
  update: (key: string, value: string) => void
  csvHref?: string
  csvAction?: ReactNode
}) {
  return (
    <div className="border-b border-border px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex flex-wrap items-baseline gap-1.5">
          <h2 className="text-body font-medium">Event registrations</h2>
          {data && (
            <span className="text-caption text-muted-foreground">
              <span aria-hidden="true">· </span>
              {data.count_label}
            </span>
          )}
        </div>
        {csvAction ?? (
          <Button variant="outline" size="sm" className="shrink-0 gap-1.5" asChild>
            <a href={csvHref} download>
              <Download aria-hidden="true" className="size-3.5" />
              CSV
            </a>
          </Button>
        )}
      </div>
      {data?.has_registrations !== false && (
        <div className="flex flex-wrap items-center gap-2 pt-2">
          <Input
            aria-label="Search events"
            placeholder="Search events"
            className="h-9 w-56"
            value={params.get('q') ?? ''}
            onChange={(event) => update('q', event.target.value)}
          />
          <FilterDropdown
            label="When"
            emptyLabel="When"
            options={[
              { value: 'upcoming', label: 'Upcoming' },
              { value: 'past', label: 'Past' },
            ]}
            selected={selection(params, 'when')}
            onChange={(values) => update('when', [...values].join(','))}
          />
          <FilterDropdown
            label="Year"
            emptyLabel="Year"
            options={data?.years ?? []}
            selected={selection(params, 'year')}
            onChange={(values) => update('year', [...values].join(','))}
          />
        </div>
      )}
    </div>
  )
}
function selection(params: URLSearchParams, key: string) {
  return new Set(params.get(key)?.split(',').filter(Boolean) ?? [])
}
